module.exports = __webpack_public_path__ + "pc/img/logo1.dbdfd39f.png";